module.exports = __webpack_public_path__ + "img/kim_josef.43bdc9c0.jpg";